import { Grid, Paper, Button, Box } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import { hasAtLeastOneValue, nl3PackageSchedulesInitialValues, nl3PackageSchedulesProperties, nl3PackageSchedulesValidationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";

export function Nl3LiveclassSchedulesFilter({setSearchPayload,
  setPage,
  clearValuesTrigger}) {

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    nl3PackageSchedulesInitialValues,
    nl3PackageSchedulesValidationSchema,
    "",
  );

  const handleSearch = () => {
    const payload: any = {};

    const searchId = watch("searchId");
    if(searchId) payload.searchId=parseInt(searchId);

    const nlearn3LiveclassPackageIds = watch("nlearn3LiveclassPackageIds");
    if(nlearn3LiveclassPackageIds?.length > 0) payload.liveclassPackageIds=nlearn3LiveclassPackageIds;

    const status = watch("status");
    if(status) payload.status=status;

    const isActive = watch("isActive");
    if (isActive === "true") payload.isActive = true;
    else if (isActive === "false") payload.isActive = false;

    const meetingTitle = watch("meetingTitle");
    if(meetingTitle) payload.meetingTitle=meetingTitle;

    const cancelledAt = watch("cancelled_at");
    if(cancelledAt?.[0]) payload.cancelledFrom=formatDateUtc(cancelledAt[0]);
    if(cancelledAt?.[1]) payload.cancelledTill=formatDateUtc(cancelledAt[1], true);

    const completedAt = watch("completed_at");
    if(completedAt?.[0]) payload.completedFrom=formatDateUtc(completedAt[0]);
    if(completedAt?.[1]) payload.completedTill=formatDateUtc(completedAt[1], true);

    const createdAt = watch("created_at");
    if(createdAt?.[0]) payload.createdFrom=formatDateUtc(createdAt[0]);
    if(createdAt?.[1]) payload.createdTill=formatDateUtc(createdAt[1], true);

    const updatedAt = watch("updated_at");
    if(updatedAt?.[0]) payload.updatedFrom=formatDateUtc(updatedAt[0]);
    if(updatedAt?.[1]) payload.updatedTill=formatDateUtc(updatedAt[1], true);

    const scheduledStartTime = watch("scheduled_start_time");
    if(scheduledStartTime?.[0]) payload.scheduledStartFrom=formatDateUtc(scheduledStartTime[0]);
    if(scheduledStartTime?.[1]) payload.scheduledStartTill=formatDateUtc(scheduledStartTime[1], true);

    const scheduledEndTime = watch("scheduled_end_time");
    if(scheduledEndTime?.[0]) payload.scheduledEndFrom=formatDateUtc(scheduledEndTime[0]);
    if(scheduledEndTime?.[1]) payload.scheduledEndTill=formatDateUtc(scheduledEndTime[1], true);

    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () =>{
    setValue("searchId","");
    setValue("nlearn3LiveclassPackageIds","");
    // setValue("liveSessionId","");
    setValue("status","");
    setValue("isActive","");
    setValue("meetingTitle","");
    setValue("cancelled_at",[null, null]);
    setValue("completed_at",[null, null]);
    setValue("created_at",[null, null]);
    setValue("updated_at",[null, null]);
    setValue("scheduled_start_time",[null, null]);
    setValue("scheduled_end_time",[null, null]);
    setSearchPayload({});
    setPage(1);
  }

  useEffect(()=>{
    clearFilter()
  },[clearValuesTrigger])

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt:3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={nl3PackageSchedulesProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "75px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["searchId","nlearn3LiveclassPackageIds","status","isActive","meetingTitle","created_at","updated_at","cancelled_at","completed_at","scheduled_start_time","scheduled_end_time"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "75px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["searchId","nlearn3LiveclassPackageIds","status","isActive","meetingTitle","created_at","updated_at","cancelled_at","completed_at","scheduled_start_time","scheduled_end_time"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
